export default {
    'PREGÃO ELETRÔNICO': 'Pregão Eletrônico',
    'CONCORRÊNCIA': 'Concorrência Eletrônica',
    'LEILÃO ELETRÔNICO': 'Leilão Eletrônico',
    'PREGÃO PRESENCIAL': 'Pregão Presencial',
    'CREDENCIAMENTO': 'Credenciamento',
    'DIÁLOGO COMPETITIVO': 'Diálogo Competitivo',
    'CONCURSO': 'Concurso',
    'CONCORRÊNCIA PRESENCIAL': 'Concorrência Presencial',
    'MANIFESTAÇÃO DE INTERESSE': 'Manifestação de Interesse',
    'PRÉ QUALIFICAÇÃO': 'Pré Qualificação',
    'LEILÃO PRESENCIAL': 'Leilão Presencial',
    'INAPLICABILIDADE DA LICITAÇÃO': 'Inaplicabilidade da Licitação'
}
